import React from "react";
import { Card, Progress, Statistic, Alert } from "antd";
import dayjs from "dayjs";

const formatPeriodDate = (dateString) => {
  if (!dateString) return "-";
  return dayjs(dateString).format("DD.MM.YYYY");
};

const MonthlyUsageCard = ({ usage }) => {
  if (!usage) return null;

  const isUnlimited = usage.limit === null || usage.limit === undefined;

  if (isUnlimited) {
    return (
      <Card title="Bu Ay Damga Kullanımı" size="small" style={{ marginTop: 16 }}>
        <Statistic value={usage.used ?? 0} suffix="damga" />
        <p style={{ color: "#888", fontSize: 12, marginTop: 8, marginBottom: 0 }}>
          Pro plan — sınırsız
        </p>
        <p style={{ color: "#888", fontSize: 11, marginTop: 4, marginBottom: 0 }}>
          Dönem: {formatPeriodDate(usage.periodStart)} – {formatPeriodDate(usage.periodEnd)}
        </p>
      </Card>
    );
  }

  const used = usage.used ?? 0;
  const limit = usage.limit;
  const percent = limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const status = usage.exceeded ? "exception" : usage.nearLimit ? "active" : "normal";
  const strokeColor = usage.exceeded
    ? "#ff4d4f"
    : usage.nearLimit
    ? "#faad14"
    : "#1890ff";

  return (
    <Card
      title="Bu Ay Damga Kullanımı (Starter)"
      size="small"
      style={{ marginTop: 16 }}>
      <Statistic value={used} suffix={`/ ${limit}`} />
      <Progress percent={percent} status={status} strokeColor={strokeColor} />
      {usage.exceeded && (
        <Alert
          message="Bu ay 100 damga limiti doldu. Bir sonraki ayın 1'ine kadar yeni damga basılamaz."
          type="error"
          showIcon
          style={{ marginTop: 8 }}
        />
      )}
      {usage.nearLimit && !usage.exceeded && (
        <Alert
          message={`Limit yaklaşıyor — ${Math.max(0, limit - used)} damga kaldı.`}
          type="warning"
          showIcon
          style={{ marginTop: 8 }}
        />
      )}
      <p style={{ color: "#888", fontSize: 11, marginTop: 8, marginBottom: 0 }}>
        Dönem: {formatPeriodDate(usage.periodStart)} – {formatPeriodDate(usage.periodEnd)}
      </p>
    </Card>
  );
};

export default MonthlyUsageCard;
